export default "__VITE_ASSET__a47d35e5__"